import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "max-w-[280px]" };
import ETooltip from '@common/ui/ETooltip.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EHelp',
    props: {
        text: {},
        icon: { default: 'question-rounded' },
        width: {},
        iconClass: { default: 'w-4 h-4 text-gray-300' },
        trigger: { default: 'hover' },
        unselectable: { type: Boolean, default: true }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createBlock(ETooltip, {
                trigger: _ctx.trigger,
                class: "flex items-center",
                inline: "",
                unselectable: _ctx.unselectable
            }, {
                tooltip: _withCtx(function () { return [
                    _createElementVNode("div", {
                        style: _normalizeStyle({
                            width: _ctx.width ? _ctx.width + 'px' : 'auto',
                        }),
                        class: "text-center inline-flex items-center"
                    }, [
                        _renderSlot(_ctx.$slots, "custom-tooltip"),
                        _renderSlot(_ctx.$slots, "default", {}, function () { return [
                            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.text), 1)
                        ]; })
                    ], 4)
                ]; }),
                default: _withCtx(function () { return [
                    _createVNode(_component_e_icon, {
                        class: _normalizeClass([_ctx.iconClass, "cursor-help"]),
                        icon: _ctx.icon
                    }, null, 8, ["class", "icon"])
                ]; }),
                _: 3
            }, 8, ["trigger", "unselectable"]));
        };
    }
});
